(() => {
  function useThreeReviewPages(widget) {
    const productId = widget.dataset.productId;
    if (!window.__frFuyuReviewFetch) {
      const original = window.fetch;
      const products = new Set();
      window.__frFuyuReviewFetch = { products };
      window.fetch = function (input, options) {
        try {
          const request = input instanceof Request;
          const url = new URL(request ? input.url : input, location.href);
          const method = options?.method || (request ? input.method : 'GET');
          if (method.toUpperCase() === 'GET' && (url.hostname === 'judge.me' || url.hostname.endsWith('.judge.me')) && url.pathname === '/reviews/reviews_for_widget' && products.has(url.searchParams.get('product_id'))) {
            url.searchParams.set('per_page', '3');
            input = request ? new Request(url, input) : url.href;
          }
        } catch {}
        return original.call(this, input, options);
      };
    }
    window.__frFuyuReviewFetch.products.add(productId);
  }
  function mount(slot) {
    if (slot.dataset.frReviewsBound) return;
    const section = document.querySelector('.fr-judgeme-reviews');
    if (!section) return;
    const wrapper = section.closest('.shopify-section') || section;
    slot.append(wrapper);
    slot.dataset.frReviewsBound = 'true';
    const widget = section.querySelector('#judgeme_product_reviews');
    const nav = section.querySelector('[data-fr-jm-outer]');
    if (!widget || !nav) return;
    useThreeReviewPages(widget);
    slot.style.overflowAnchor = 'none';
    const previous = nav.querySelector('[data-fr-jm-prev]');
    const next = nav.querySelector('[data-fr-jm-next]');
    let signature = '';
    let pending = false;
    let refreshSignature = '';
    let timer;
    let frame;
    let anchorFrame;
    let savedAnchor;
    function holdViewport() {
      cancelAnimationFrame(anchorFrame);
      const root = document.documentElement;
      savedAnchor ||= { value: root.style.getPropertyValue('overflow-anchor'), priority: root.style.getPropertyPriority('overflow-anchor') };
      root.style.setProperty('overflow-anchor', 'none', 'important');
    }
    function restoreAnchor() {
      if (!savedAnchor) return;
      const root = document.documentElement;
      if (savedAnchor.value) root.style.setProperty('overflow-anchor', savedAnchor.value, savedAnchor.priority);
      else root.style.removeProperty('overflow-anchor');
      savedAnchor = undefined;
    }
    function releaseViewport() {
      cancelAnimationFrame(anchorFrame);
      anchorFrame = requestAnimationFrame(() => { anchorFrame = requestAnimationFrame(restoreAnchor); });
    }
    const items = () => [...widget.querySelectorAll('.jm-review-item[review-uuid]')];
    const nativeButtons = () => {
      const buttons = [...widget.querySelectorAll('.jm-pagination-controls__button--nav')];
      return { previous: buttons[0], next: buttons.at(-1) };
    };
    function render() {
      widget.querySelectorAll('.jm-pagination-controls').forEach(node => node.style.setProperty('display', 'none', 'important'));
      const reviews = items();
      if (!reviews.length && pending) return;
      const key = reviews.map(item => item.getAttribute('review-uuid')).join('|');
      if (key !== signature) {
        signature = key;
        pending = false;
        clearTimeout(timer);
        releaseViewport();
      }
      reviews.forEach((item, index) => {
        if (index < 3) item.style.setProperty('display', 'block', 'important');
        else item.style.setProperty('display', 'none', 'important');
      });
      if (reviews.length <= 3) refreshSignature = '';
      else if (refreshSignature !== key) {
        const select = widget.querySelector('.jm-sort-filter__select');
        if (select) {
          refreshSignature = key;
          pending = true;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          clearTimeout(timer);
          timer = setTimeout(() => { pending = false; render(); }, 15000);
        }
      }
      const native = nativeButtons();
      previous.disabled = pending || !native.previous || native.previous.disabled;
      next.disabled = pending || !native.next || native.next.disabled;
      nav.hidden = !reviews.length || (!pending && previous.disabled && next.disabled);
      nav.setAttribute('aria-busy', String(pending));
    }
    function nativePage(button) {
      if (!button || button.disabled || pending) return;
      holdViewport();
      pending = true;
      render();
      timer = setTimeout(() => { pending = false; releaseViewport(); render(); }, 15000);
      // Judge.me scrolls synchronously on pagination; the review change stays in place.
      const scrollTo = window.scrollTo;
      window.scrollTo = () => {};
      try { button.click(); }
      finally { window.scrollTo = scrollTo; }
    }
    next.addEventListener('click', () => nativePage(nativeButtons().next));
    previous.addEventListener('click', () => nativePage(nativeButtons().previous));
    const observer = new MutationObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(render);
    });
    observer.observe(widget, { childList: true, subtree: true });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(slot)) return;
      observer.disconnect();
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      cancelAnimationFrame(anchorFrame);
      restoreAnchor();
    });
    render();
  }
  const init = () => document.querySelectorAll('[data-fr-fuyu-review-slot]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
